/**
 * Socket.io istemcisi — real-time bildirimler.
 * Token ile kimlik doğrulama.
 */
import { io, Socket } from 'socket.io-client'
import { getAccessToken } from './api'
import { toast } from 'sonner'
import i18n from '../i18n'

let _socket: Socket | null = null

export function connectSocket(): Socket {
  if (_socket?.connected) return _socket

  _socket = io(import.meta.env.VITE_WS_URL ?? '', {
    auth: { token: getAccessToken() },
    transports: ['websocket'],
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
  })
  // Masaüstü: Veri Merkezi güncellenmeden önce bağlı herkese duyuru
  _socket.on('system:announce', (p: { message: string; seconds: number }) => {
    toast.warning(i18n.t('desktop:updater.announce', { seconds: p.seconds }), { duration: p.seconds * 1000, id: 'system-announce' })
  })

  return _socket
}

export function disconnectSocket(): void {
  _socket?.disconnect()
  _socket = null
}

export function getSocket(): Socket | null {
  return _socket
}
